import React from 'react';
import PropTypes from 'prop-types';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import GuideCallout, { GuideCalloutOption } from '../shared/GuideCallout';

/**
 * Speech-bubble guide shown once a new user's first Watchlist is published.
 * It points at Settings in the side menu (on narrow screens, at the button
 * that opens the menu) and says where to see which securities were resolved
 * and which weren't. It waits while another guide is showing.
 */
export default function SecurityResolutionHint({ open, anchorEl, onOpen, onDismiss }) {
  return (
    <GuideCallout
      open={open}
      anchorEl={anchorEl}
      ariaLabel="Check your securities"
      title="Check your securities"
      subtitle="Your Watchlist is ready. Settings → Security Resolution shows which securities were resolved and which weren't."
      onDismiss={onDismiss}
      waitForOtherGuides
    >
      <GuideCalloutOption
        icon={<SettingsOutlinedIcon sx={{ fontSize: 18 }} />}
        label="Open Security Resolution"
        detail="It's always under Settings in the side menu"
        onClick={onOpen}
      />
    </GuideCallout>
  );
}

SecurityResolutionHint.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  onOpen: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};
